import { render, staticRenderFns } from "./Scrubber.vue?vue&type=template&id=0180a469&scoped=true&"
import script from "./Scrubber.vue?vue&type=script&lang=js&"
export * from "./Scrubber.vue?vue&type=script&lang=js&"
import style0 from "./Scrubber.vue?vue&type=style&index=0&id=0180a469&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0180a469",
  null
  
)

component.options.__file = "Scrubber.vue"
export default component.exports